/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetEventVolumePayload,
  GetEventVolumePayload$Outbound,
  GetEventVolumePayload$outboundSchema,
} from "../components/geteventvolumepayload.js";

export type GetEventVolumeSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetEventVolumeRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  getEventVolumePayload: GetEventVolumePayload;
};

/** @internal */
export type GetEventVolumeSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetEventVolumeSecurity$outboundSchema: z.ZodMiniType<
  GetEventVolumeSecurity$Outbound,
  GetEventVolumeSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getEventVolumeSecurityToJSON(
  getEventVolumeSecurity: GetEventVolumeSecurity,
): string {
  return JSON.stringify(
    GetEventVolumeSecurity$outboundSchema.parse(getEventVolumeSecurity),
  );
}

/** @internal */
export type GetEventVolumeRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  GetEventVolumePayload: GetEventVolumePayload$Outbound;
};

/** @internal */
export const GetEventVolumeRequest$outboundSchema: z.ZodMiniType<
  GetEventVolumeRequest$Outbound,
  GetEventVolumeRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    getEventVolumePayload: GetEventVolumePayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      getEventVolumePayload: "GetEventVolumePayload",
    });
  }),
);

export function getEventVolumeRequestToJSON(
  getEventVolumeRequest: GetEventVolumeRequest,
): string {
  return JSON.stringify(
    GetEventVolumeRequest$outboundSchema.parse(getEventVolumeRequest),
  );
}
